<template>
  <b-card
    no-body
    class="p-2"
  >
    <h2 class="mt-3">
      Seus Leads:
    </h2>
    <div class="row mt-1 align-content-center mb-2 ">
      <div class="col-2 ">
        <b-form-group>
          <label class="d-inline-block text-sm-left mr-50">Mostrar</label>
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            :options="pageOptions"
            class="w-50"
          />
        </b-form-group>
      </div>
      <div class="row col-12 col-md-10 justify-content-end pr-0">
        <div class="col-12 col-md-2">
          <b-form-group
            label-for="defaultLabel"
          >
            <b-form-input
              id="defaultLabel"
              v-model="dadosFiltra"
              placeholder="Pesquisar dados"
              @input="filtrarPorDados()"
            />
          </b-form-group>
        </div>
        <div class="col-12 col-md-2">
          <el-dropdown id="filter-select-fluxo">
            <el-select
              v-model="selectedValue1"
              placeholder="Selecione o fluxo"
            >
              <el-option
                value="Todos"
                label="Todos os fluxos"
              />
              <el-option
                v-for="item in chats"
                :id="item.id"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-dropdown>
        </div>
        <div class="col-12 col-md-2">
          <el-dropdown id="filter-select-periodo">
            <el-select
              v-model="selectedValue"
              placeholder="Selecione o periodo"
            >
              <el-option
                v-for="item in option"
                :id="item.title"
                :key="item.title"
                :label="item.title"
                :value="item.title"
              />
            </el-select>
          </el-dropdown>
        </div>
      </div>
    </div>

    <b-col
      cols="12"
      class="px-0"
    >
      <b-table
        striped
        hover
        responsive
        :per-page="perPage"
        :current-page="currentPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
      >
        <template #cell(capa)="data">
          <b-avatar :src="data.value" />
        </template>

        <template #cell(tipo)>
          <b-badge variant="success">
            Completo
          </b-badge>
        </template>
        <template v-slot:cell(delete)="row">
          <div
            class="d-flex"
            style="gap: 20px"
          >
            <b-button
              id="btn-visualizar-leads"
              variant="info"
              size="sm"
              @click="mudarRota(row.item.id_conversa);setdadosFiltro()"
            >
              <feather-icon
                icon="EyeIcon"
                stroke="white"
              />
            </b-button>
            <b-button
              id="btn-deletar-leads"
              variant="danger"
              size="sm"
              @click="showModalDelete(row.item.id_conversa)"
            >
              <feather-icon
                icon="TrashIcon"
                stroke="white"
              />
            </b-button>
          </div>
        </template>

      </b-table>
    </b-col>

    <b-col
      cols="12"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="center"
        size="sm"
        class="my-0"
      />
    </b-col>
    <b-modal
      id="modal-delete-lead"
      title="Confirmação de exclusão de Lead"
      cancel-title="cancelar"
      cancel-variant="outline-secondary"
      ok-variant="danger"
      ok-title="Deletar"
      centered
      @ok="deletarChat()"
    >
      <b-card-text>
        <slot name="content-message">
          Tem certeza de que deseja <strong>excluir</strong> esse lead?
        </slot>
      </b-card-text>
    </b-modal>

  </b-card>

</template>

<script>
import {
  BTable, BRow, BCol, BFormGroup, BAvatar, BPagination, BBadge, BButton, BFormSelect, BCard,
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { useApi } from '@/composables/useApi'
import persistencias from '@/views/App/Chat/persistencia'
import { recuperarSelecaoVisualizacao, salvarSelecaoVisualizacao } from '@/views/App/Chat/persistencia';

const apiBack = useApi()

export default {
  components: {
    BFormSelect,
    BButton,
    BCard,
    BBadge,
    BPagination,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BTable,
    vSelect,
  },
  data() {
    return {
      fields: [
        // {
        //   key: 'id', label: 'Id',
        // },
        { key: 'Dados', label: 'Dados' },
        { key: 'name', label: 'Fluxo' },
        { key: 'created_at', label: 'CRIADO EM', sortable: true },
        { key: 'origem', label: 'Origem' },
        { key: 'tipo', label: 'Tipo', sortable: true },
        { key: 'delete', label: 'Ações', sortable: true },
      ],

      // status: [{
      //   1: 'Ativo', 0: 'Inativo',
      // },
      // {
      //   0: 'light-primary', 1: 'light-success',
      // }],
      sortBy: '',
      resposta: '',
      dadosFiltra: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      currentPage: 1,
      totalRows: 1,
      perPage: 5,
      pageOptions: [3, 5, 10, 15],
      leadSelecionado: '',
      selectedValue1: '',
      selectedValue: '',
      option: [{ title: 'Ontem' }, { title: 'Hoje' }, { title: 'Ultimos 7 dias' }, { title: 'Ultimos 30 dias' }, { title: 'Tudo' }],
      items: [],
      chats: [],
    }
  },
  computed: {
    getUserData() {
      return JSON.parse(localStorage.getItem('userData'))
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  watch: {
    selectedValue1(newValue) {
      if (newValue === 'Todos' && this.selectedValue === 'Tudo' && this.dadosFiltra === '') {
        console.log('leads')
        this.listaLead()
        return
      }
      if (newValue === 'Todos' && this.selectedValue === '' && this.dadosFiltra === '') {
        console.log('leads')
        this.listaLead()
        return
      }
      // if (newValue === 'Todos' && this.selectedValue !== '') {
      //   console.log('filtroData')
      //   this.filtroData()
      // }
      if (newValue) {
        if (this.dadosFiltra !== '') {
          console.log('FiltrarPorDados')
          this.filtrarPorDados()
        } else {
          console.log('filtroFluxo')
          this.filtroFluxo()
        }
      }
    },
    selectedValue(newValue) {
      if (this.dadosFiltra !== '') {
        console.log('filtrarPorDados')
        this.filtrarPorDados()
      } else {
        this.filtroData()
      }
      if (newValue === 'Tudo' && this.selectedValue1 === 'Todos') {
        console.log('listaLead')
        this.listaLead()
      }
    },
    dadosFiltra(newValue) {
      console.log('filtrarPorDados', newValue)
      this.filtrarPorDados()
    },
  },
  async mounted() {
    await this.listaLead()
    await this.listaChat()
    await this.getdadosFiltro()
    this.totalRows = this.items.length

    // Recuperar dados do localStorage ao iniciar a aplicação
    const leadData = localStorage.getItem('leadData');
    if (leadData) {
      this.items = JSON.parse(leadData);
    }

    // Recuperar o número de leads por página do localStorage
    const leadsPerPage = localStorage.getItem('leadsPerPage');
    // Definir o valor padrão como 5 caso não haja nenhum valor salvo
    this.perPage = leadsPerPage ? parseInt(leadsPerPage) : 5;

    // Lidar com o evento personalizado para atualizar a seleção de perPage
    document.addEventListener('updatePerPage', (event) => {
      this.perPage = event.detail;
    });
  },
  methods: {
    async setdadosFiltro() {
      localStorage.setItem('filtroDADOS', this.dadosFiltra)
      localStorage.setItem('filtroCHAT', this.selectedValue1)
      localStorage.setItem('filtroPeriodo', this.selectedValue)
      localStorage.setItem('leadsPerPage', this.perPage.toString()); // Adicionando configuração para salvar apenas o número de leads por página
    },
    async getdadosFiltro() {
      console.log(localStorage.getItem('filtroDADOS'))
      console.log(localStorage.getItem('filtroCHAT'))
      console.log(localStorage.getItem('filtroPeriodo'))
      this.selectedValue1 = localStorage.getItem('filtroCHAT')
      this.selectedValue = localStorage.getItem('filtroPeriodo')
      this.dadosFiltra = localStorage.getItem('filtroDADOS')
      localStorage.setItem('filtroDADOS', '')
      localStorage.setItem('filtroCHAT', '')
      localStorage.setItem('filtroPeriodo', '')
      // this.filtroFluxo()
    },
    async listaLead() {
      await apiBack.get(`leads/${this.getUserData.id}`)
        .then(response => {
          this.items = response.data
          console.log(this.items)
          // Salvar dados no localStorage
          localStorage.setItem('leadData', JSON.stringify(this.items));
        })
        .catch(error => {
          console.log(error)
        })
    },
    async deletarChat() {
      await apiBack.delete(`/leads/${this.leadSelecionado}`)
        .then(response => {
          this.listaLead()
          this.$message({
            type: 'success',
            message: 'Deletado com sucesso',
          })
        })
        .catch(err => console.error(err))
    },
    async listaChat() {
      await apiBack.get(`chat/${this.getUserData.id}`)
        .then(response => {
          this.chats = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    async filtroFluxo() {
      if (this.dadosFiltra !== '') {
        console.log()
        await apiBack.post('filterDados', {
          periodo: this.selectedValue === '' ? 'Tudo' : this.selectedValue,
          id_chat: (this.selectedValue1 === '' || this.selectedValue1 === 'Todos') ? 0 : this.selectedValue1,
          value: this.dadosFiltra,
          id_user: this.getUserData.id,
        })
          .then(response => {
            this.items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      } else if (this.selectedValue === '') {
        await apiBack.get(`leadsChat/${this.selectedValue1}`)
          .then(response => {
            this.items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        await apiBack.post('getDataChat', {
          periodo: this.selectedValue,
          id_chat: this.selectedValue1,
        })
          .then(response => {
            this.items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    showModalDelete(item) {
      this.leadSelecionado = item
      this.$bvModal.show('modal-delete-lead')
    },
    async filtroData() {
      if (this.selectedValue1 === '' || this.selectedValue1 === 'Todos') {
        await apiBack.post('getData', {
          periodo: this.selectedValue,
          id_user: this.getUserData.id,
        })
          .then(response => {
            this.items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        await apiBack.post('getDataChat', {
          periodo: this.selectedValue,
          id_chat: this.selectedValue1,
        })
          .then(response => {
            this.items = response.data
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
    mudarRota(id) {
      return this.$router.push(`/detalhelead/${id}`)
    },
    onFiltered(filteredItems) {
      console.log(filteredItems)
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async filtrarPorDados() {
      await apiBack.post('filterDados', {
        periodo: this.selectedValue === '' ? 'Tudo' : this.selectedValue,
        id_chat: (this.selectedValue1 === '' || this.selectedValue1 === 'Todos') ? 0 : this.selectedValue1,
        value: this.dadosFiltra,
        id_user: this.getUserData.id,
      })
        .then(response => {
          this.items = response.data
          console.log('items', this.items)
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
